import type { AssistantUsageTopic } from '@/api/assistantInsights/assistantInsightsApi.types';
import { resolveSeriesColor } from '@/theme/chartPalette';
import { BRAND_COLOR_TOKENS } from '@/theme/designTokens';
import { USAGE_TOPICS } from './usageFilters';

const GENERAL_TOPIC = 'general';

export function resolveTopicColor(topic: string): string {
  if (topic === GENERAL_TOPIC) {
    return BRAND_COLOR_TOKENS.muted;
  }
  const index = (USAGE_TOPICS as string[]).indexOf(topic);
  return resolveSeriesColor(index === -1 ? USAGE_TOPICS.length : index);
}

export function isKnownTopic(value: string): value is AssistantUsageTopic {
  return (USAGE_TOPICS as string[]).includes(value);
}
